//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'

export default {
  name: "sendOrderDetailMore",
  components: {
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    toAll(){
      this.$router.push({name:'sendOrderDetailAll'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/sendOrder/detailMore.vue